import React, { useState } from "react";
import { FaStar } from "react-icons/fa";

function StarRating({ state, setState, scoreHandler, id, style, end, text }) {
  const [rating, setRating] = useState(null);
  const [hover, setHover] = useState(null);

  const handler = value => {
    setRating(value);
    setState({ ...state, score: value });
    if (scoreHandler) {
      scoreHandler({ score: value, id });
    }
  };
  return (
    <div
      className={`d-flex align-items-center ${
        end && "justify-content-between"
      }`}
      style={{ ...style }}
    >
      <div>
        <p style={{ margin: 0 }}>{text}</p>
      </div>
      <div>
        {[...Array(5)].map((star, i) => {
          const ratinValue = i + 1;
          return (
            <label key={i}>
              <input
                type="radio"
                name="rating"
                value={ratinValue}
                onClick={() => handler(ratinValue)}
                style={{ display: "none" }}
              />
              <FaStar
                className="star"
                color={ratinValue <= (hover || rating) ? "#ffc107" : "#e4e5e9"}
                size={20}
                onMouseOver={() => setHover(ratinValue)}
                onMouseLeave={() => setHover(null)}
              />
            </label>
          );
        })}
      </div>
    </div>
  );
}

export default StarRating;
